import { css } from 'styled-components';

const style = () => css`
    width: 100%;
`;

export default style();
